import type { PolicyDetailsDTO } from '../../../infrastructure/models';

export type GroupedPolicyResults = Array<{
  type: string;
  results: PolicyDetailsDTO['results'];
}>;

export const groupPolicyResultsByType = (
  results: PolicyDetailsDTO['results']
): GroupedPolicyResults => {
  if (!results?.length) {
    return [];
  }

  return results.reduce<GroupedPolicyResults>((acc, result) => {
    const normalizedType = (result.type ?? '').trim();
    const groupType = normalizedType.length > 0 ? normalizedType : 'Other';
    const existingGroup = acc.find((group) => group.type === groupType);

    if (existingGroup) {
      existingGroup.results.push(result);
    } else {
      acc.push({ type: groupType, results: [result] });
    }

    return acc;
  }, []);
};
